module.exports = __webpack_public_path__ + "static/media/slaven.738c702b.jpg";